export default __webpack_public_path__ + "static/media/lining17.5123b86d.jpg";